import {SpanIcon} from '@mazraeapp/react_icon_kit';
import {useEffect, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

const Success = () => {
  const navigate = useNavigate();
  const {state}: IuseLocationState = useLocation();
  const [count, setCount] = useState(5);

  useEffect(() => {
    localStorage.removeItem('sponsorForm');
    const timer = setInterval(() => {
      setCount(prevCount => {
        if (prevCount === 1) {
          clearInterval(timer);
          navigate('/sponsor/activePlane', {replace: true});
          return 0;
        }
        return prevCount - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="w-full h-dvh flex items-center justify-center">
      <div className="text-center w-4/5">
        <SpanIcon className="icon-nameCheck-circle1 text-green-500 text-6xl" />
        <h2 className="text-green-500 text-lg mt-3">
          عملیات با موفقیت انجام شد
        </h2>
        <div className="my-6 text-green-500">{count}</div>
        <p className="text-sm text-gray-900 font-medium mb-7">
          پرداخت شما با شماره پیگیری {state?.data?.RRN} با موفقیت انجام شد و
          اکانت مورد نظر برای شما فعال شد.
        </p>
        <button
          onClick={() => navigate('/sponsor/activePlane')}
          className="bg-green-500 text-white rounded-md px-8 py-2 text-md w-full border-none"
        >
          تایید و ادامه
        </button>
      </div>
    </div>
  );
};

export default Success;
